import {
    AfterViewInit,
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {DateTimeUtils} from 'src/libs/core/src/utils/date-time.utils';
import * as moment from 'moment';
import {
    validDateCustom,
    validateMaxCurrentDate, RequireTypeFile, CustomeDateNotEqualValidators, ValidatorCustom
} from 'src/app/core/helper/validator-custom/ValidatorCustom';
import {CustomFormatDate} from 'src/assets/pipes/custom-format-date.pipe';
import {EmployeeService, ContractService} from '../../../core';
import {MIME_TYPE, ROLE_LIST, URL_IMAGE_PREV} from '../../../core/common/constant';
import {UserStorage} from '../../../core/storage/user.storage';
import {FileService} from '../../../core/services/file.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ContractViewComponent} from '../contract-view/contract-view.component';
import * as FileSaver from 'file-saver';
import {TranslateService} from '@ngx-translate/core';
import {ToastrMessageService} from '../../../core/services/toastr.message.service';
import {CONFIG} from '../../../core/config/application.config';
import {OauthService} from '../../../core/services/oauth.service';
import { FormControl } from '@angular/forms';
import {DatePipe} from '@angular/common';

declare const $: any;
const convertStringToDate = DateTimeUtils.convertStringToDate;

interface Field {
    fieldName: string,
    value?: any,
    isDisabled?: boolean,
    validators?: ValidatorFn[]
}

@Component({
    selector: 'app-contract-modal',
    templateUrl: './contract-modal.component.html',
    styleUrls: ['./contract-modal.component.css'],
})
export class ContractModalComponent implements OnInit, OnChanges, AfterViewInit {
    public collaboratorsContractInforForm: FormGroup;
    public formalContractInforForm: FormGroup;
    public probationContractInforForm: FormGroup;
    public rejectForm: FormGroup;
    public collaboratorsContractType = 'HDDV';
    public formalContractType = 'HDLD';
    public probationContractType = 'HDTV';
    public isShow = false;
    public isFirst = false;
    public flag: boolean = false;
    public maxLength: number = 35;
    public employees = [];
    public isNew = false;
    @Input()
    public idModal: string = 'add_contract';
    @Input() value: any = null;
    @Input() employeeId: any = '';
    @Input() employeeCode: any = '';
    @Input() data: any = '';
    @Output() onSubmit = new EventEmitter<any>();
    @Output() onApprove = new EventEmitter<any>();
    @Output() onClose = new EventEmitter<any>();
    public isDisabled: Boolean = false;
    public textPattern = '[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\\s\\W|_]+$'

    public currentDate = new Date();
    public imageUrl = URL_IMAGE_PREV.url;
    public selectOption: any = this.collaboratorsContractType;
    public employeeSelected: any = '';
    roles = this.userStorage.getUserRoles();
    listContract;
    modalRef: BsModalRef;
    canEdit = false;
    canSendApprove = false;
    canApprove = false;

    constructor(
        private toastr: ToastrService,
        private formBuilder: FormBuilder,
        private employeeService: EmployeeService,
        private contractService: ContractService,
        private customFormatDate: CustomFormatDate,
        private userStorage: UserStorage,
        private fileService: FileService,
        private translate: TranslateService,
        public toastrMessage: ToastrMessageService,
        private modalService: BsModalService,
        private oauthService: OauthService,
        private datePipe: DatePipe
    ) {
        this.canEdit = this.oauthService.validatePermission(CONFIG.PERMISSION.EDIT_CONTRACT, false);
        this.canSendApprove = this.oauthService.validatePermission(CONFIG.PERMISSION.EDIT_STATUS_UNAPPROVE_CONTRACT, false);
        this.canApprove = this.oauthService.validatePermission(CONFIG.PERMISSION.EDIT_STATUS_WAITING_APPROVE_CONTRACT, false);
        this.generateForm();
    }

    ngAfterViewInit(): void {
        const modal: any = $('#' + this.idModal);
        modal?.modal({
            backdrop: 'static',
        });
        modal?.on('show.bs.modal', () => {
            $('#' + this.idModal + ' input[type=file]').each((index, element) => {
                $(element).val('');
            })
            this.collaboratorsContractInforForm.reset();
            this.formalContractInforForm.reset();
            this.probationContractInforForm.reset();
            this.loadEmployee();
            this.listContract = ContractService.listCollaborators
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value || changes.value == null) {
            this.loadData();
        }
    }

    isRequire(fieldName: string) {
        if (this.selectOption == this.collaboratorsContractType) {
            return this.collaboratorsContractInforForm.controls[fieldName].hasValidator(Validators.required);
        } else if (this.selectOption == this.formalContractType) {
            return this.formalContractInforForm.controls[fieldName].hasValidator(Validators.required);
        } else if (this.selectOption == this.probationContractType) {
            return this.probationContractInforForm.controls[fieldName].hasValidator(Validators.required);
        }
        return false;
    }

    async updateControl(form: FormGroup, listField: Field[] | string[] | any [], isDisabled = true) {
        if (form) {
            for (let index = 0; index < listField.length; index++) {
                let item = listField[index]
                if (typeof item == 'string') {
                    form.controls[item].enable();
                    if (isDisabled == true) {
                        form.controls[item].disable();
                    } else if (isDisabled == false) {
                        form.controls[item].enable();
                    }
                } else {
                    item = listField[index] as Field;
                    form.controls[item.fieldName].enable();
                    if (item.value) {
                        form.controls[item.fieldName].setValue(item.value);
                    }
                    if (!item.validators) {
                        item.validators = [];
                    }
                    if (item.validators && item.validators.length >= 0) {
                        let currentValue = form.controls[item.fieldName].value;
                        if (item.value) {
                            currentValue = item.value;
                        }
                        form.controls[item.fieldName].setValidators(item.validators);
                        form.controls[item.fieldName].updateValueAndValidity();
                        form.controls[item.fieldName].reset(currentValue ? currentValue : '');
                    }
                    if (item.isDisabled) {
                        form.controls[item.fieldName].disable();
                    }
                }
                if (this.onlyView()) {
                    form.controls[item.fieldName].disable();
                }
            }
            form.updateValueAndValidity();
            form.reset(form.getRawValue());
        }
    }

    async setDefaultValue(value: any) {
        this.isFirst = false;
        this.isNew = false;
        if (this.data && this.data.isFirstContract) {
            this.isFirst = true;
            this.isNew = true;
        }
        let employeeSelect = value?.employeeId ? {id: value?.employeeId} : '';
        if (this.collaboratorsContractInforForm) {
            this.collaboratorsContractInforForm.enable()
            this.collaboratorsContractInforForm.setValue({
                id: value?.id ? value?.id : '',
                contractCode: value?.contractCode ? value?.contractCode : '',
                laborContractStatus: value?.laborContractStatus ? value?.laborContractStatus : '',
                startDate: value?.startDate ? convertStringToDate(value.startDate) : '',
                endDate: value?.endDate ? convertStringToDate(value.endDate) : '',
                negotiableSalary: value?.negotiableSalary ? value?.negotiableSalary : '',
                resultEvaluation: value?.resultEvaluation ? value?.resultEvaluation : '',
                contractSalary: value?.contractSalary ? value?.contractSalary : '',
                contractTerminationDate: value?.contractTerminationDate ? convertStringToDate(value.contractTerminationDate) : '',
                contractTerm: value?.contractTerm ? value?.contractTerm : '',
                employee: employeeSelect,
                laborContractPath: this.fileUploadName,
                agreementFilePath: this.fileUploadAgreementName,
                agreementNo: this.value?.agreementNo ? this.value.agreementNo : '',
                agreementSigningDate: this.value?.agreementSigningDate ? convertStringToDate(this.value.agreementSigningDate) : ''
            });
            this.collaboratorsContractInforForm.get('contractTerm').setValue(value?.contractTerm ? value?.contractTerm : '')
        }
        if (this.formalContractInforForm) {
            this.formalContractInforForm.enable();
            this.formalContractInforForm.setValue({
                id: value?.id ? value?.id : '',
                contractCode: value?.contractCode ? value?.contractCode : '',
                laborContractStatus: value?.laborContractStatus ? value?.laborContractStatus : '',
                startDate: value?.startDate ? convertStringToDate(value.startDate) : '',
                endDate: value?.endDate ? convertStringToDate(value.endDate) : '',
                contractTerm: value?.contractTerm ? value?.contractTerm : '',
                insuranceSalary: value?.insuranceSalary ? value?.insuranceSalary : '',
                netSalary: value?.netSalary ? value?.netSalary : '',
                grossSalary: value?.grossSalary ? value?.grossSalary : '',
                resultEvaluation: value?.resultEvaluation ? value?.resultEvaluation : '',
                contractTerminationDate: value?.contractTerminationDate ? convertStringToDate(value.contractTerminationDate) : '',
                employee: employeeSelect,
                laborContractPath: this.fileUploadName,
                agreementFilePath: this.fileUploadAgreementName,
                agreementNo: this.value?.agreementNo ? this.value.agreementNo : '',
                agreementSigningDate: this.value?.agreementSigningDate ? convertStringToDate(this.value.agreementSigningDate) : '',
                decisionNo: this.value?.decisionNo ? this.value.decisionNo : '',
                decisionSigningDate: this.value?.decisionSigningDate ? convertStringToDate(this.value.decisionSigningDate) : '',
                decisionFilePath: this.fileUploadDecisionName
            });
        }
        if (this.probationContractInforForm) {
            this.probationContractInforForm.enable();
            this.probationContractInforForm.setValue({
                id: value?.id ? value?.id : '',
                contractCode: value?.contractCode ? value?.contractCode : '',
                laborContractStatus: value?.laborContractStatus ? value?.laborContractStatus : '',
                startDate: value?.startDate ? convertStringToDate(value.startDate) : '',
                endDate: value?.endDate ? convertStringToDate(value.endDate) : '',
                contractTerminationDate: value?.contractTerminationDate ? convertStringToDate(value.contractTerminationDate) : '',
                resultEvaluation: value?.resultEvaluation ? value?.resultEvaluation : '',
                officialSalary: value?.officialSalary ? value?.officialSalary : '',
                employee: employeeSelect,
                probationalSalary: value?.probationalSalary ? value?.probationalSalary : '',
                contractTerm: value?.contractTerm ? value?.contractTerm : '',
                laborContractPath: this.fileUploadName,
                agreementFilePath: this.fileUploadAgreementName,
                agreementNo: this.value?.agreementNo ? this.value.agreementNo : '',
                agreementSigningDate: this.value?.agreementSigningDate ? convertStringToDate(this.value.agreementSigningDate) : ''
            });
        }
        if (value?.employeeCode) {
            this.isFirst = value.isFirstContract;
            if (this.isFirst) {
                this.updateControl(this.formalContractInforForm, [
                    {
                        fieldName: 'laborContractPath',
                        isDisabled: false,
                        validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]
                    },
                ]);
            }
        }

        if (value?.contractType) {
            this.selectOption = value?.contractType;
            this.isShow = true;

            this.collaboratorsContractInforForm.disable();
            this.probationContractInforForm.disable();
            this.formalContractInforForm.disable();

            this.collaboratorsContractInforForm.controls['resultEvaluation'].enable();
            this.probationContractInforForm.controls['resultEvaluation'].enable();
            this.formalContractInforForm.controls['resultEvaluation'].enable();

            this.collaboratorsContractInforForm.controls['contractTerminationDate'].enable();
            this.probationContractInforForm.controls['contractTerminationDate'].enable();
            this.formalContractInforForm.controls['contractTerminationDate'].enable();

            this.collaboratorsContractInforForm.controls['laborContractPath'].enable();
            this.probationContractInforForm.controls['laborContractPath'].enable();
            this.formalContractInforForm.controls['laborContractPath'].enable();

            this.updateControl(this.formalContractInforForm, [
                {
                    fieldName: 'grossSalary',
                },
            ])
        }
        if (!value) {
            this.isShow = false;
            this.isNew = true;
            if (this.collaboratorsContractInforForm) {
                this.collaboratorsContractInforForm.enable();
                this.updateControl(this.collaboratorsContractInforForm, [
                    {fieldName: 'employee', isDisabled: false, validators: [Validators.required]},
                    {fieldName: 'resultEvaluation', isDisabled: false, validators: []},
                    {fieldName: 'contractTerminationDate', isDisabled: false, validators: []},
                    {fieldName: 'endDate', isDisabled: true, validators: []},
                    {
                        fieldName: 'laborContractPath',
                        isDisabled: false,
                        validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]
                    },
                    'startDate', 'contractTerm', 'negotiableSalary', 'contractSalary'], false);
            }
            if (this.formalContractInforForm) {
                this.formalContractInforForm.enable();
                this.updateControl(this.formalContractInforForm, [
                    {fieldName: 'employee', isDisabled: false, validators: []},
                    {fieldName: 'resultEvaluation', isDisabled: false, validators: []},
                    {fieldName: 'contractTerminationDate', isDisabled: false, validators: []},
                    {fieldName: 'endDate', isDisabled: true, validators: []},
                    {
                        fieldName: 'laborContractPath',
                        isDisabled: false,
                        validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]
                    },
                    'startDate', 'contractTerm', 'insuranceSalary', 'netSalary', 'grossSalary'], false);
            }
            if (this.probationContractInforForm) {
                this.probationContractInforForm.enable();
                this.updateControl(this.probationContractInforForm, [
                    {fieldName: 'employee', isDisabled: false, validators: []},
                    {fieldName: 'resultEvaluation', isDisabled: false, validators: []},
                    {fieldName: 'contractTerminationDate', isDisabled: false, validators: []},
                    {fieldName: 'endDate', isDisabled: true, validators: []},
                    {
                        fieldName: 'laborContractPath',
                        isDisabled: false,
                        validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]
                    },
                    'startDate', 'contractTerm', 'probationalSalary', 'officialSalary'], false);
            }
        } else if (value?.laborContractStatus == 'EXPIRED') {
            this.collaboratorsContractInforForm.disable();
            this.probationContractInforForm.disable();
            this.formalContractInforForm.disable();

            this.updateControl(this.collaboratorsContractInforForm, [{
                fieldName: 'laborContractPath',
                validators: [Validators.required],
                isDisabled: true
            }]);
            this.updateControl(this.probationContractInforForm, [{
                fieldName: 'laborContractPath',
                validators: [Validators.required],
                isDisabled: true
            }]);
            this.updateControl(this.formalContractInforForm, [{
                fieldName: 'laborContractPath',
                validators: [Validators.required],
                isDisabled: true
            }]);
        } else if (value?.laborContractStatus == 'UNAPPROVE') {
            let listControls = [
                {fieldName: 'employee', validators: [], isDisabled: true},
                {fieldName: 'contractTerminationDate', validators: [validDateCustom]},
                {fieldName: 'resultEvaluation', validators: [Validators.maxLength(500)]}
            ]
            this.collaboratorsContractInforForm.enable();
            this.probationContractInforForm.enable();
            this.formalContractInforForm.enable();
            this.updateControl(this.collaboratorsContractInforForm, [...listControls,
                {fieldName: 'startDate', validators: [Validators.required], isDisabled: true},
                {fieldName: 'contractCode', validators: [], isDisabled: false},
                {fieldName: 'startDate', validators: [Validators.required], isDisabled: true},
                {fieldName: 'contractTerm', validators: [Validators.required], isDisabled: this.isFirst},
                {fieldName: 'endDate', isDisabled: true},
                {
                    fieldName: 'laborContractPath',
                    validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                    isDisabled: false
                },
            ]);
            this.updateControl(this.probationContractInforForm, [...listControls,
                {fieldName: 'startDate', validators: [Validators.required], isDisabled: false},
                {fieldName: 'contractCode', validators: [], isDisabled: false},
                {fieldName: 'contractTerm', validators: [Validators.required], isDisabled: this.isFirst},
                {fieldName: 'endDate', isDisabled: true},
                {fieldName: 'officialSalary', validators: [Validators.required], isDisabled: this.isFirst},
                {fieldName: 'probationalSalary', validators: [Validators.required], isDisabled: this.isFirst},
                {
                    fieldName: 'laborContractPath',
                    validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                    isDisabled: false
                },
            ]);
            this.updateControl(this.formalContractInforForm, [...listControls,
                {fieldName: 'startDate', validators: [Validators.required], isDisabled: true},
                {fieldName: 'contractCode', validators: [], isDisabled: false},
                {fieldName: 'contractTerm', validators: [Validators.required], isDisabled: this.isFirst},
                {fieldName: 'endDate', isDisabled: true},

                {fieldName: 'insuranceSalary', validators: [Validators.required], isDisabled: this.isFirst},
                {fieldName: 'netSalary', validators: [Validators.required], isDisabled: this.isFirst},
                {
                    fieldName: 'laborContractPath',
                    validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                    isDisabled: false
                },
            ]);
        } else if (value?.laborContractStatus == 'PENDING') {
            let listControls = [
                {fieldName: 'employee', validators: [], isDisabled: true},
                {fieldName: 'contractTerminationDate', validators: [validDateCustom]},
                {fieldName: 'resultEvaluation', validators: [Validators.maxLength(500)]}
            ]
            this.collaboratorsContractInforForm.enable();
            this.probationContractInforForm.enable();
            this.formalContractInforForm.enable();
            this.updateControl(this.collaboratorsContractInforForm, [...listControls,
                {fieldName: 'startDate', validators: [Validators.required], isDisabled: false},
                {fieldName: 'contractCode', validators: [], isDisabled: false},
                {fieldName: 'contractTerm', validators: [Validators.required]},
                {fieldName: 'endDate', isDisabled: true, validators: []},
                {
                    fieldName: 'laborContractPath',
                    validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                    isDisabled: false
                },
            ]);
            this.updateControl(this.probationContractInforForm, [...listControls,
                {fieldName: 'startDate', validators: [Validators.required]},
                {fieldName: 'contractCode', validators: [], isDisabled: false},
                {fieldName: 'contractTerm', validators: [Validators.required]},
                {fieldName: 'officialSalary', validators: [Validators.required]},
                {fieldName: 'probationalSalary', validators: [Validators.required]},
                {fieldName: 'endDate', isDisabled: true, validators: []},
                {
                    fieldName: 'laborContractPath',
                    validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]
                },
            ]);
            this.updateControl(this.formalContractInforForm, [...listControls,
                {fieldName: 'startDate', validators: [Validators.required]},
                {fieldName: 'contractCode', validators: [], isDisabled: false},
                {fieldName: 'contractTerm', validators: [Validators.required]},
                {fieldName: 'endDate', isDisabled: true, validators: []},

                {fieldName: 'insuranceSalary', validators: [Validators.required]},
                {fieldName: 'netSalary', validators: [Validators.required]},
                {
                    fieldName: 'laborContractPath',
                    validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]
                },
            ]);
        } else if (this.value?.laborContractStatus == 'WAITING_APPROVE') {
            this.collaboratorsContractInforForm.disable();
            this.probationContractInforForm.disable();
            this.formalContractInforForm.disable();
        } else if (this.value?.laborContractStatus == 'EFFECT') {
            let listControls = [{
                fieldName: 'contractTerminationDate',
                validators: [validDateCustom],
                isDisabled: false
            },
                {
                    fieldName: 'resultEvaluation',
                    validators: [Validators.maxLength(500)],
                    isDisabled: false
                },
                {
                    fieldName: 'startDate',
                    validators: [Validators.required],
                    isDisabled: false
                },
                {
                    fieldName: 'endDate',
                    validators: [],
                    isDisabled: true
                },
                {
                    fieldName: 'contractCode',
                    validators: [],
                    isDisabled: false
                },
                {
                    fieldName: 'laborContractPath',
                    validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                    isDisabled: true
                }];
            this.updateControl(this.collaboratorsContractInforForm, listControls);
            this.updateControl(this.probationContractInforForm, listControls);
            this.updateControl(this.formalContractInforForm, [...listControls,
                {fieldName: 'grossSalary', validators: [], isDisabled: true},
            ]);
        } else {
            if (this.collaboratorsContractInforForm || this.probationContractInforForm || this.formalContractInforForm) {
                let listControls = [
                    {fieldName: 'contractTerminationDate', validators: [validDateCustom]},
                    {fieldName: 'resultEvaluation', validators: [Validators.maxLength(500)]}
                ]
                this.collaboratorsContractInforForm.enable();
                this.probationContractInforForm.enable();
                this.formalContractInforForm.enable();
                this.updateControl(this.collaboratorsContractInforForm, [...listControls,
                    {fieldName: 'startDate', validators: [Validators.required], isDisabled: false},
                    {fieldName: 'contractCode', validators: [], isDisabled: false},
                    {fieldName: 'contractTerm', validators: [Validators.required], isDisabled: this.isFirst},
                    {fieldName: 'endDate', validators: [], isDisabled: true},
                    {
                        fieldName: 'laborContractPath',
                        validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                        isDisabled: false
                    },
                ]);
                this.updateControl(this.probationContractInforForm, [...listControls,
                    {fieldName: 'startDate', validators: [Validators.required], isDisabled: false},
                    {fieldName: 'contractCode', validators: [], isDisabled: false},
                    {fieldName: 'contractTerm', validators: [Validators.required], isDisabled: this.isFirst},
                    {fieldName: 'endDate', validators: [], isDisabled: true},
                    {fieldName: 'officialSalary', validators: [Validators.required], isDisabled: this.isFirst},
                    {fieldName: 'probationalSalary', validators: [Validators.required], isDisabled: this.isFirst},
                    {
                        fieldName: 'laborContractPath',
                        validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                        isDisabled: false
                    },
                ]);
                this.updateControl(this.formalContractInforForm, [...listControls,
                    {fieldName: 'startDate', validators: [Validators.required], isDisabled: false},
                    {fieldName: 'contractCode', validators: [], isDisabled: false},
                    {fieldName: 'contractTerm', validators: [Validators.required], isDisabled: this.isFirst},
                    {fieldName: 'endDate', validators: [], isDisabled: true},

                    {fieldName: 'insuranceSalary', validators: [Validators.required], isDisabled: this.isFirst},
                    {fieldName: 'netSalary', validators: [Validators.required], isDisabled: this.isFirst},
                    {
                        fieldName: 'laborContractPath',
                        validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                        isDisabled: false
                    },
                ]);
            }
        }
        this.updateControl(this.collaboratorsContractInforForm, [
            {fieldName: 'contractCode', validators: [], isDisabled: false},
        ]);
        this.updateControl(this.probationContractInforForm, [
            {fieldName: 'contractCode', validators: [], isDisabled: false},
        ]);
        this.updateControl(this.formalContractInforForm, [
            {fieldName: 'contractCode', validators: [], isDisabled: false},
        ]);
        if (this.onlyView()) {
            this.formalContractInforForm.disable();
            this.collaboratorsContractInforForm.disable();
            this.probationContractInforForm.disable();
        }
    }

    enableForm() {
        if (this.onlyView()) {
            this.formalContractInforForm.disable();
            this.collaboratorsContractInforForm.disable();
            this.probationContractInforForm.disable();
            return;
        }
        if (this.collaboratorsContractInforForm) {
            this.collaboratorsContractInforForm.enable();
            this.collaboratorsContractInforForm.get('endDate')?.disable();
        }
        if (this.probationContractInforForm) {
            this.probationContractInforForm.enable();
            this.probationContractInforForm.get('endDate')?.disable();
        }
        if (this.formalContractInforForm) {
            this.formalContractInforForm.enable();
            this.formalContractInforForm.get('endDate')?.disable();
        }
    }

    onChangeSelect() {
        if (this.collaboratorsContractType == this.selectOption) {
            this.listContract = ContractService.listCollaborators
            this.collaboratorsContractInforForm.reset();
        } else if (this.formalContractType == this.selectOption) {
            this.listContract = ContractService.listFormal
            this.formalContractInforForm.reset();
        } else if (this.probationContractType == this.selectOption) {
            this.listContract = ContractService.listProbation
            this.probationContractInforForm.reset();
        }
        this.enableForm();
        if (this.value) {
            if (this.collaboratorsContractType == this.value.contractType) {
                this.collaboratorsContractInforForm.setValue({
                    id: this.value?.id ? this.value?.id : '',
                    contractCode: this.value?.contractCode ? this.value?.contractCode : '',
                    laborContractStatus: this.value?.laborContractStatus ? this.value?.laborContractStatus : '',
                    startDate: this.value?.startDate ? convertStringToDate(this.value.startDate) : '',
                    endDate: this.value?.endDate ? convertStringToDate(this.value.endDate) : '',
                    negotiableSalary: this.value?.negotiableSalary ? this.value?.negotiableSalary : '',
                    resultEvaluation: this.value?.resultEvaluation ? this.value?.resultEvaluation : '',
                    contractSalary: this.value?.contractSalary ? this.value?.contractSalary : '',
                    contractTerminationDate: this.value?.contractTerminationDate ? convertStringToDate(this.value.contractTerminationDate) : '',
                    contractTerm: this.value?.contractTerm ? this.value?.contractTerm : '',
                    employee: this.value?.employeeId ? this.value?.employeeId : '',
                    laborContractPath: this.fileUploadName,
                    agreementFilePath: this.fileUploadAgreementName,
                    agreementNo: this.value?.agreementNo ? this.value.agreementNo : '',
                    agreementSigningDate: this.value?.agreementSigningDate ? convertStringToDate(this.value.agreementSigningDate) : '',
                });
            }
            if (this.formalContractType == this.value.contractType) {
                this.formalContractInforForm.setValue({
                    id: this.value?.id ? this.value?.id : '',
                    contractCode: this.value?.contractCode ? this.value?.contractCode : '',
                    laborContractStatus: this.value?.laborContractStatus ? this.value?.laborContractStatus : '',
                    startDate: this.value?.startDate ? convertStringToDate(this.value.startDate) : '',
                    endDate: this.value?.endDate ? convertStringToDate(this.value.endDate) : '',
                    contractTerm: this.value?.contractTerm ? this.value?.contractTerm : '',
                    insuranceSalary: this.value?.insuranceSalary ? this.value?.insuranceSalary : '',
                    netSalary: this.value?.netSalary ? this.value?.netSalary : '',
                    grossSalary: this.value?.grossSalary ? this.value?.grossSalary : '',
                    resultEvaluation: this.value?.resultEvaluation ? this.value?.resultEvaluation : '',
                    contractTerminationDate: this.value?.contractTerminationDate ? convertStringToDate(this.value.contractTerminationDate) : '',
                    employee: this.value?.employeeId ? this.value?.employeeId : '',
                    laborContractPath: this.fileUploadName,
                    agreementFilePath: this.fileUploadAgreementName,
                    agreementNo: this.value?.agreementNo ? this.value.agreementNo : '',
                    agreementSigningDate: this.value?.agreementSigningDate ? convertStringToDate(this.value.agreementSigningDate) : '',
                    decisionNo: this.value?.decisionNo ? this.value.decisionNo : '',
                    decisionSigningDate: this.value?.decisionSigningDate ? convertStringToDate(this.value.decisionSigningDate) : '',
                    decisionFilePath: this.fileUploadDecisionName
                });
            }
            if (this.probationContractType == this.value.contractType) {
                this.probationContractInforForm.setValue({
                    id: this.value?.id ? this.value?.id : '',
                    contractCode: this.value?.contractCode ? this.value?.contractCode : '',
                    laborContractStatus: this.value?.laborContractStatus ? this.value?.laborContractStatus : '',
                    startDate: this.value?.startDate ? convertStringToDate(this.value.startDate) : '',
                    endDate: this.value?.endDate ? convertStringToDate(this.value.endDate) : '',
                    contractTerminationDate: this.value?.contractTerminationDate ? convertStringToDate(this.value.contractTerminationDate) : '',
                    resultEvaluation: this.value?.resultEvaluation ? this.value?.resultEvaluation : '',
                    officialSalary: this.value?.officialSalary ? this.value?.officialSalary : '',
                    probationalSalary: this.value?.probationalSalary ? this.value?.probationalSalary : '',
                    contractTerm: this.value?.contractTerm ? this.value?.contractTerm : '',
                    employee: this.value?.employeeId ? this.value?.employeeId : '',
                    laborContractPath: this.fileUploadName,
                    agreementFilePath: this.fileUploadAgreementName,
                    agreementNo: this.value?.agreementNo ? this.value.agreementNo : '',
                    agreementSigningDate: this.value?.agreementSigningDate ? convertStringToDate(this.value.agreementSigningDate) : ''
                });
            }
        } else {
            this.generateContractCode();
        }
    }

    private generateContractCode() {
        this.contractService.generateContractCode(this.selectOption).subscribe(result => {
            if (this.collaboratorsContractType == this.selectOption) {
                this.collaboratorsContractInforForm.get('contractCode').setValue(result.data);
            } else if (this.formalContractType == this.selectOption) {
                this.formalContractInforForm.get('contractCode').setValue(result.data);
            } else if (this.probationContractType == this.selectOption) {
                this.probationContractInforForm.get('contractCode').setValue(result.data);
            }
        });
    }

    async onChangeEmployee(value: any) {
        if (this.isShow == false || this.employeeId) {
            let employeeFinder = value;
            if (this.employeeId) {
                employeeFinder = this.employees.find(el => el.employeeId == this.employeeId);
            }
            if (this.employeeId) {
                this.collaboratorsContractInforForm.controls['employee'].setValue(employeeFinder);
                this.formalContractInforForm.controls['employee'].setValue(employeeFinder);
                this.probationContractInforForm.controls['employee'].setValue(employeeFinder);
            }
            if (employeeFinder) {
                this.employeeSelected = employeeFinder;
                this.isFirst = false;
                let employeeContract = this.data;
                if (!employeeContract) {
                    let result_employee: any = await this.employeeService.findById(this.employeeSelected.employeeId).toPromise();
                    employeeContract = result_employee?.data;
                }
                this.isFirst = employeeContract?.isFirstContract;
                const condidateInfo_result: any = employeeContract?.contractId ? await this.contractService.findById(employeeContract?.contractId).toPromise() : null;
                const condidateInfo = condidateInfo_result ? condidateInfo_result.data : null;
                if (this.isFirst) {
                    this.selectOption = condidateInfo ? condidateInfo.contractType : this.selectOption;
                }
                console.log(condidateInfo);
                let hasFirst = !this.value?.id && !!condidateInfo;
                if (this.selectOption == this.collaboratorsContractType) {
                    let listControl = [
                        {
                            fieldName: 'startDate',
                            value: hasFirst ? convertStringToDate(condidateInfo.endDate) : this.value ? convertStringToDate(this.value.startDate) : convertStringToDate(employeeFinder.startDate),
                            validators: [Validators.required],
                            isDisabled: false
                        },
                        {
                            fieldName: 'contractTerm',
                            value: hasFirst ? condidateInfo.contractTerm : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'negotiableSalary',
                            value: hasFirst ? condidateInfo.negotiableSalary : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'contractSalary',
                            value: hasFirst ? condidateInfo.contractSalary : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'employee',
                            value: employeeFinder,
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'laborContractPath',
                            value: this.fileUploadName,
                            validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                        },
                    ];
                    this.updateControl(this.collaboratorsContractInforForm, listControl);
                } else if (this.selectOption == this.formalContractType) {
                    let listControl = [
                        {
                            fieldName: 'startDate',
                            value: hasFirst ? convertStringToDate(condidateInfo.endDate) : this.value ? convertStringToDate(this.value.startDate) : convertStringToDate(employeeFinder.startDate),
                            validators: [Validators.required],
                            isDisabled: false
                        },
                        {
                            fieldName: 'contractTerm',
                            value: hasFirst ? condidateInfo.contractTerm : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'insuranceSalary',
                            value: hasFirst ? condidateInfo.insuranceSalary : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'netSalary',
                            value: hasFirst ? condidateInfo.netSalary : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'grossSalary',
                            isDisabled: false,
                        },
                        {
                            fieldName: 'employee',
                            value: employeeFinder,
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'laborContractPath',
                            value: this.fileUploadName,
                            validators: [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)],
                        },
                    ];
                    this.updateControl(this.formalContractInforForm, listControl);
                } else if (this.selectOption == this.probationContractType) {
                    let listControl = [
                        {
                            fieldName: 'startDate',
                            value: hasFirst ? convertStringToDate(condidateInfo.endDate) : this.value ? convertStringToDate(this.value.startDate) : convertStringToDate(employeeFinder.startDate),
                            validators: [Validators.required],
                            isDisabled: false
                        },
                        {
                            fieldName: 'contractTerm',
                            value: hasFirst ? condidateInfo.contractTerm : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'probationalSalary',
                            value: hasFirst ? condidateInfo.probationalSalary : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'officialSalary',
                            value: hasFirst ? condidateInfo.officialSalary : '',
                            validators: [Validators.required],
                        },
                        {
                            fieldName: 'employee',
                            value: employeeFinder,
                            validators: [Validators.required],
                        },
                    ];
                    this.updateControl(this.probationContractInforForm, listControl);
                }
            }
        }
    }

    ngOnInit() {
        this.rejectForm = this.formBuilder.group({
            note: ['', [Validators.required, Validators.maxLength(500)]]
        });
        // { validators: [CustomeDateNotEqualValidators.fromToDate('startDate', 'endDate', 'startToEnd'), CustomeDateNotEqualValidators.fromToDate('workingTimeFrom', 'workingTimeWithStackFrom', 'workTimeStartToEnd')]};
        this.loadData();
        this.loadEmployee();
    }

    generateForm() {
        this.collaboratorsContractInforForm = this.formBuilder.group({
            id: ['', []],
            contractCode: ['', [Validators.required, Validators.maxLength(100)]],
            laborContractStatus: ['', []],
            startDate: ['', [validDateCustom, validateMaxCurrentDate]],
            endDate: ['', []],
            negotiableSalary: ['', [Validators.required, ValidatorCustom.maxLengthCurrency(10), Validators.pattern('[a-zA-z0-9,]+')]],
            resultEvaluation: ['', [Validators.maxLength(50)]],
            contractSalary: ['', [Validators.required, ValidatorCustom.maxLengthCurrency(10), Validators.pattern('[a-zA-z0-9,]+')]],
            contractTerminationDate: ['', [validDateCustom]],
            employee: ['', [Validators.required]],
            laborContractPath: ['', [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]],
            contractTerm: ['', [Validators.required]],
            agreementNo: ['', [Validators.required]],
            agreementSigningDate: ['', [Validators.required]],
            agreementFilePath: ['', [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]],
        }, {validators: [
            CustomeDateNotEqualValidators.fromToDate('startDate', 'contractTerminationDate', 'fromToDate', 0),
            CustomeDateNotEqualValidators.fromToDate('agreementSigningDate', 'contractTerminationDate', 'agreementSigningDateError', 0),
        ]});
        // { validators: [CustomeDateNotEqualValidators.fromToDate('startDate', 'endDate', 'startToEnd'), CustomeDateNotEqualValidators.fromToDate('workingTimeFrom', 'workingTimeWithStackFrom', 'workTimeStartToEnd')]};
        this.formalContractInforForm = this.formBuilder.group({
            id: ['', []],
            contractCode: ['', [Validators.required, Validators.maxLength(100)]],
            laborContractStatus: ['', []],
            startDate: ['', [validDateCustom, validateMaxCurrentDate]],
            endDate: ['', []],
            contractTerm: ['', [Validators.required]],
            insuranceSalary: ['', [Validators.required, ValidatorCustom.maxLengthCurrency(10), Validators.pattern('[a-zA-z0-9,]+')]],
            netSalary: ['', [Validators.required, ValidatorCustom.maxLengthCurrency(10), Validators.pattern('[a-zA-z0-9,]+')]],
            grossSalary: ['', [ValidatorCustom.maxLengthCurrency(10), Validators.pattern('[a-zA-z0-9,]+')]],
            resultEvaluation: ['', [Validators.maxLength(50)]],
            contractTerminationDate: ['', [validDateCustom]],
            employee: ['', [Validators.required]],
            laborContractPath: ['', [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]],
            agreementNo: ['', [Validators.required]],
            agreementSigningDate: ['', [Validators.required]],
            decisionNo: ['', [Validators.required]],
            decisionSigningDate: ['', [Validators.required]],
            agreementFilePath: ['', [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]],
            decisionFilePath: ['', [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]],

        }, {validators: [
            CustomeDateNotEqualValidators.fromToDate('startDate', 'contractTerminationDate', 'fromToDate', 0),
            CustomeDateNotEqualValidators.fromToDate('agreementSigningDate', 'contractTerminationDate', 'agreementSigningDateError', 0),
            CustomeDateNotEqualValidators.fromToDate('decisionSigningDate', 'contractTerminationDate', 'decisionSigningDateError', 0)
        ]});
        // { validators: [CustomeDateNotEqualValidators.fromToDate('startDate', 'endDate', 'startToEnd'), CustomeDateNotEqualValidators.fromToDate('workingTimeFrom', 'workingTimeWithStackFrom', 'workTimeStartToEnd')]};
        this.probationContractInforForm = this.formBuilder.group({
            id: ['', []],
            contractCode: ['', [Validators.required, Validators.maxLength(100)]],
            laborContractStatus: ['', []],
            startDate: ['', [validDateCustom, validateMaxCurrentDate]],
            endDate: ['', []],
            contractTerminationDate: ['', [validDateCustom]],
            resultEvaluation: ['', [Validators.maxLength(50)]],
            officialSalary: ['', [Validators.required, ValidatorCustom.maxLengthCurrency(10), Validators.pattern('[a-zA-z0-9,]+')]],
            employee: ['', [Validators.required]],
            probationalSalary: ['', [Validators.required, ValidatorCustom.maxLengthCurrency(10), Validators.pattern('[a-zA-z0-9,]+')]],
            contractTerm: ['', [Validators.required]],
            laborContractPath: ['', [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]],
            agreementNo: ['', [Validators.required]],
            agreementSigningDate: ['', [Validators.required]],
            agreementFilePath: ['', [Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]],
        }, {validators: [
            CustomeDateNotEqualValidators.fromToDate('startDate', 'contractTerminationDate', 'fromToDate', 0),
            CustomeDateNotEqualValidators.fromToDate('agreementSigningDate', 'contractTerminationDate', 'agreementSigningDateError', 0),
        ]});

        this.formalContractInforForm.controls['agreementFilePath'].valueChanges.subscribe(value => {
            console.log(this.formalContractInforForm.controls['agreementFilePath']);
        })
        this.collaboratorsContractInforForm.controls['contractTerm'].valueChanges.subscribe(value => {
            if (value) {
                let startDate = this.collaboratorsContractInforForm.controls['startDate'].value;
                let month = this.collaboratorsContractInforForm.controls['contractTerm'].value;
                if (month == -1) {
                    this.collaboratorsContractInforForm.controls['endDate'].patchValue('');
                } else {
                    this.collaboratorsContractInforForm.controls['endDate'].patchValue(moment(startDate).add(month / 1, 'month').add(-1, 'day').toDate());
                }
            } else if (value != '') this.collaboratorsContractInforForm.controls['contractTerm'].setValue('');
        });
        this.formalContractInforForm.controls['contractTerm'].valueChanges.subscribe(value => {
            if (value) {
                let startDate = this.formalContractInforForm.controls['startDate'].value;
                let month = this.formalContractInforForm.controls['contractTerm'].value;
                if (month == -1) {
                    this.collaboratorsContractInforForm.controls['endDate'].patchValue('');
                } else {
                    this.formalContractInforForm.controls['endDate'].patchValue(moment(startDate).add(month / 1, 'month').add(-1, 'day').toDate());
                }
            } else if (value != '') this.formalContractInforForm.controls['contractTerm'].setValue('');
        });
        this.probationContractInforForm.controls['contractTerm'].valueChanges.subscribe(value => {
            if (value) {
                let startDate = this.probationContractInforForm.controls['startDate'].value;
                let month = this.probationContractInforForm.controls['contractTerm'].value;
                if (month == -1) {
                    this.collaboratorsContractInforForm.controls['endDate'].patchValue('');
                } else {
                    this.probationContractInforForm.controls['endDate'].patchValue(moment(startDate).add(month / 1, 'month').add(-1, 'day').toDate());
                }
            } else if (value != '') this.probationContractInforForm.controls['contractTerm'].setValue('');
        });

        this.collaboratorsContractInforForm.controls['startDate'].valueChanges.subscribe(value => {
            if (value) {
                let month = this.collaboratorsContractInforForm.controls['contractTerm'].value;
                if (!month || month == -1) {
                    this.collaboratorsContractInforForm.controls['endDate'].patchValue('');
                } else {
                    this.collaboratorsContractInforForm.controls['endDate'].patchValue(moment(value).add(month / 1, 'month').add(-1, 'day').toDate());
                }
            } else this.collaboratorsContractInforForm.controls['endDate'].setValue('');
        });
        this.formalContractInforForm.controls['startDate'].valueChanges.subscribe(value => {
            if (value) {
                let month = this.formalContractInforForm.controls['contractTerm'].value;
                if (!month || month == -1) {
                    this.formalContractInforForm.controls['endDate'].patchValue('');
                } else {
                    this.formalContractInforForm.controls['endDate'].patchValue(moment(value).add(month / 1, 'month').add(-1, 'day').toDate());
                }
            } else this.formalContractInforForm.controls['endDate'].setValue('');
        });
        this.probationContractInforForm.controls['startDate'].valueChanges.subscribe(value => {
            if (value) {
                let month = this.probationContractInforForm.controls['contractTerm'].value;
                if (!month || month == -1) {
                    this.probationContractInforForm.controls['endDate'].patchValue('');
                } else {
                    this.probationContractInforForm.controls['endDate'].patchValue(moment(value).add(month / 1, 'month').add(-1, 'day').toDate());
                }
            } else this.probationContractInforForm.controls['endDate'].setValue('');
        });

        this.formalContractInforForm.controls['contractTerminationDate'].valueChanges.subscribe(value => {
            if (this.isTerminate()) {
                this.formalContractInforForm.get('agreementNo').setValidators([Validators.required]);
                this.formalContractInforForm.get('agreementSigningDate').setValidators([Validators.required]);
                this.formalContractInforForm.get('agreementFilePath').setValidators([Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]);
                this.formalContractInforForm.get('decisionNo').setValidators([Validators.required]);
                this.formalContractInforForm.get('decisionSigningDate').setValidators([Validators.required]);
                this.formalContractInforForm.get('decisionFilePath').setValidators([Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]);
            } else {
                this.formalContractInforForm.get('agreementNo').setValidators([]);
                this.formalContractInforForm.get('agreementSigningDate').setValidators([]);
                this.formalContractInforForm.get('agreementFilePath').setValidators([]);
                this.formalContractInforForm.get('decisionNo').setValidators([]);
                this.formalContractInforForm.get('decisionSigningDate').setValidators([]);
                this.formalContractInforForm.get('decisionFilePath').setValidators([]);
            }
        })
        this.probationContractInforForm.controls['contractTerminationDate'].valueChanges.subscribe(value => {
            if (this.isTerminate()) {
                this.probationContractInforForm.get('agreementNo').setValidators([Validators.required]);
                this.probationContractInforForm.get('agreementSigningDate').setValidators([Validators.required]);
                this.probationContractInforForm.get('agreementFilePath').setValidators([Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]);
            } else {
                this.probationContractInforForm.get('agreementNo').setValidators([]);
                this.probationContractInforForm.get('agreementSigningDate').setValidators([]);
                this.probationContractInforForm.get('agreementFilePath').setValidators([]);
            }
        })
        this.collaboratorsContractInforForm.controls['contractTerminationDate'].valueChanges.subscribe(value => {
            if (this.isTerminate()) {
                this.collaboratorsContractInforForm.get('agreementNo').setValidators([Validators.required]);
                this.collaboratorsContractInforForm.get('agreementSigningDate').setValidators([Validators.required]);
                this.collaboratorsContractInforForm.get('agreementFilePath').setValidators([Validators.required, RequireTypeFile.typeFile(['pdf', 'doc', 'docx']), RequireTypeFile.maxSizeFile(5)]);
            } else {
                this.collaboratorsContractInforForm.get('agreementNo').setValidators([]);
                this.collaboratorsContractInforForm.get('agreementSigningDate').setValidators([]);
                this.collaboratorsContractInforForm.get('agreementFilePath').setValidators([]);
            }
        })
    }

    isTerminate() {
        if (this.selectOption === this.formalContractType) {
            return this.formalContractInforForm.get('contractTerminationDate').value && (this.formalContractInforForm.controls['contractTerm'].value === -1 || moment(this.formalContractInforForm.get('contractTerminationDate').value).diff(moment(this.formalContractInforForm.get('endDate').value), 'day') < 0)
        } else if (this.selectOption === this.collaboratorsContractType) {
            return this.collaboratorsContractInforForm.get('contractTerminationDate').value && (this.collaboratorsContractInforForm.controls['contractTerm'].value === -1 || moment(this.collaboratorsContractInforForm.get('contractTerminationDate').value).diff(moment(this.collaboratorsContractInforForm.get('endDate').value), 'day') < 0)
        } else if (this.selectOption === this.probationContractType) {
            return this.probationContractInforForm.get('contractTerminationDate').value && (this.probationContractInforForm.controls['contractTerm'].value === -1 || moment(this.probationContractInforForm.get('contractTerminationDate').value).diff(moment(this.probationContractInforForm.get('endDate').value), 'day') < 0)
        }
    }

    loadEmployee() {
        this.employeeService.getEmployeeScreenCreateContract()
            .subscribe(({data}: any) => {
                let values = data;
                if (values && typeof values.map == 'function') {
                    this.employees = values.map(el => {
                        el.label = el.employeeCode + '-' + el.fullName;
                        return el;
                    });
                    if (this.employeeId) {
                        if (this.value?.employeeId) {
                            this.employeeId = this.value.employeeId;
                        }
                        let employeeValue = this.employees.find(el => this.employeeId == el.employeeId);
                        this.onChangeEmployee(employeeValue);
                    }
                }
                this.onChangeSelect();
            }, (error: any) => {
            });
    }

    loadData() {
        this.setDefaultValue(this.value);
        if (this.value && this.canEditContractInfo()) {
            this.enableForm();
        }
    }

    onClickButtonSave() {
        let employeeCode: string = 'NA';
        if (this.data) {
            employeeCode = this.data.employeeProfile.employeeCode;
        } else if (this.employeeCode) {
            employeeCode = this.employeeCode;
        } else if (this.employeeSelected) {
            employeeCode = this.employeeSelected.employeeCode
        }
        if (this.selectOption == this.collaboratorsContractType) {
            this.collaboratorsContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.collaboratorsContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            if (this.collaboratorsContractInforForm.valid) {
                let negotiableSalary = '0';
                let contractSalary = '0';
                if (this.collaboratorsContractInforForm.getRawValue().negotiableSalary) {
                    negotiableSalary = ('' + this.collaboratorsContractInforForm.getRawValue().negotiableSalary).replace(/,/g, '');
                }
                if (this.collaboratorsContractInforForm.getRawValue().contractSalary) {
                    contractSalary = ('' + this.collaboratorsContractInforForm.getRawValue().contractSalary).replace(/,/g, '');
                }
                let employeeId = '';
                if (this.collaboratorsContractInforForm.getRawValue()?.employee) {
                    employeeId = this.collaboratorsContractInforForm.getRawValue()?.employee.employeeId;
                }
                if (!employeeId && this.employeeId) employeeId = this.employeeId;
                this.submit({
                    ...this.collaboratorsContractInforForm.getRawValue(), employeeCode, employeeId,
                    contractType: this.selectOption, negotiableSalary, contractSalary
                })
            }
        } else if (this.selectOption == this.formalContractType) {
            this.formalContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.formalContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            if (this.formalContractInforForm.valid) {
                let insuranceSalary = '0';
                let grossSalary = '0';
                let netSalary = '0';
                if (this.formalContractInforForm.getRawValue().insuranceSalary) {
                    insuranceSalary = ('' + this.formalContractInforForm.getRawValue().insuranceSalary).replace(/,/g, '');
                }
                if (this.formalContractInforForm.getRawValue().grossSalary) {
                    grossSalary = ('' + this.formalContractInforForm.getRawValue().grossSalary).replace(/,/g, '');
                }
                if (this.formalContractInforForm.getRawValue().netSalary) {
                    netSalary = ('' + this.formalContractInforForm.getRawValue().netSalary).replace(/,/g, '');
                }
                let employeeId = '';
                if (this.formalContractInforForm.getRawValue()?.employee) {
                    employeeId = this.formalContractInforForm.getRawValue()?.employee.employeeId;
                }
                if (!employeeId && this.employeeId) employeeId = this.employeeId;
                this.submit({
                    ...this.formalContractInforForm.getRawValue(),
                    contractType: this.selectOption, employeeId,
                    insuranceSalary, grossSalary, netSalary, employeeCode,
                })
            }
        } else if (this.selectOption == this.probationContractType) {
            this.probationContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.probationContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            if (this.probationContractInforForm.valid) {
                let probationalSalary = '0';
                let officialSalary = '0';
                if (this.probationContractInforForm.getRawValue().probationalSalary) {
                    probationalSalary = ('' + this.probationContractInforForm.getRawValue().probationalSalary).replace(/,/g, '');
                }
                if (this.probationContractInforForm.getRawValue().officialSalary) {
                    officialSalary = ('' + this.probationContractInforForm.getRawValue().officialSalary).replace(/,/g, '');
                }
                let employeeId = '';
                if (this.probationContractInforForm.getRawValue()?.employee) {
                    employeeId = this.probationContractInforForm.getRawValue()?.employee.employeeId;
                }
                if (!employeeId && this.employeeId) employeeId = this.employeeId;
                this.submit({
                    ...this.probationContractInforForm.getRawValue(), employeeCode, employeeId,
                    contractType: this.selectOption, probationalSalary, officialSalary
                })
            }
        }

    }

    onClickButtonSendApprove() {
        let employeeCode: string = 'AN';
        if (this.data) {
            employeeCode = this.data.employeeProfile.employeeCode;
        } else if (this.employeeCode) {
            employeeCode = this.employeeCode;
        }
        if (this.selectOption == this.collaboratorsContractType) {
            this.collaboratorsContractInforForm.markAllAsTouched();
            this.collaboratorsContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.collaboratorsContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            if (this.collaboratorsContractInforForm.valid) {
                let employeeId = '';
                if (this.collaboratorsContractInforForm.getRawValue()?.employee) {
                    employeeId = this.collaboratorsContractInforForm.getRawValue()?.employee.employeeId;
                }
                let negotiableSalary = '0';
                let contractSalary = '0';
                if (this.collaboratorsContractInforForm.getRawValue().negotiableSalary) {
                    negotiableSalary = ('' + this.collaboratorsContractInforForm.getRawValue().negotiableSalary).replace(/,/g, '');
                }
                if (this.collaboratorsContractInforForm.getRawValue().contractSalary) {
                    contractSalary = ('' + this.collaboratorsContractInforForm.getRawValue().contractSalary).replace(/,/g, '');
                }
                this.submit({
                    ...this.collaboratorsContractInforForm.getRawValue(),
                    contractType: this.selectOption,
                    isSendApproval: true,
                    employeeCode,
                    employeeId,
                    negotiableSalary,
                    contractSalary
                })
            }
        } else if (this.selectOption == this.formalContractType) {
            this.formalContractInforForm.markAllAsTouched();
            this.formalContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.formalContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            if (this.formalContractInforForm.valid) {
                let employeeId = '';
                if (this.formalContractInforForm.getRawValue()?.employee) {
                    employeeId = this.formalContractInforForm.getRawValue()?.employee.employeeId;
                }
                let insuranceSalary = '0';
                let grossSalary = '0';
                let netSalary = '0';
                if (this.formalContractInforForm.getRawValue().insuranceSalary) {
                    insuranceSalary = ('' + this.formalContractInforForm.getRawValue().insuranceSalary).replace(/,/g, '');
                }
                if (this.formalContractInforForm.getRawValue().grossSalary) {
                    grossSalary = ('' + this.formalContractInforForm.getRawValue().grossSalary).replace(/,/g, '');
                }
                if (this.formalContractInforForm.getRawValue().netSalary) {
                    netSalary = ('' + this.formalContractInforForm.getRawValue().netSalary).replace(/,/g, '');
                }
                this.submit({
                    ...this.formalContractInforForm.getRawValue(),
                    contractType: this.selectOption,
                    isSendApproval: true,
                    employeeCode,
                    employeeId,
                    grossSalary,
                    netSalary,
                    insuranceSalary
                })
            }
        } else if (this.selectOption == this.probationContractType) {
            this.probationContractInforForm.markAllAsTouched();
            this.probationContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.probationContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            if (this.probationContractInforForm.valid) {
                let employeeId = '';
                if (this.probationContractInforForm.getRawValue()?.employee) {
                    employeeId = this.probationContractInforForm.getRawValue()?.employee.employeeId;
                }
                let probationalSalary = '0';
                let officialSalary = '0';
                if (this.probationContractInforForm.getRawValue().probationalSalary) {
                    probationalSalary = ('' + this.probationContractInforForm.getRawValue().probationalSalary).replace(/,/g, '');
                }
                if (this.probationContractInforForm.getRawValue().officialSalary) {
                    officialSalary = ('' + this.probationContractInforForm.getRawValue().officialSalary).replace(/,/g, '');
                }
                this.submit({
                    ...this.probationContractInforForm.getRawValue(),
                    contractType: this.selectOption,
                    isSendApproval: true,
                    employeeCode,
                    employeeId,
                    probationalSalary,
                    officialSalary
                })
            }
        }
    }

    onClickButtonApprove() {
        let employeeCode: string = 'AN';
        if (this.data) {
            employeeCode = this.data.employeeProfile.employeeCode;
        } else if (this.employeeCode) {
            employeeCode = this.employeeCode;
        }
        if (this.selectOption == this.collaboratorsContractType) {
            this.collaboratorsContractInforForm.markAllAsTouched();
            this.collaboratorsContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.collaboratorsContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            let employeeId = '';
            if (this.collaboratorsContractInforForm.getRawValue()?.employee) {
                employeeId = this.collaboratorsContractInforForm.getRawValue()?.employee.employeeId;
            }
            this.onApproveContract({
                ...this.collaboratorsContractInforForm.getRawValue(),
                contractType: this.selectOption,
                isSendApproval: true,
                status: 'EFFECT',
                note: '',
                employeeCode,
                employeeId
            })
        } else if (this.selectOption == this.formalContractType) {
            this.formalContractInforForm.markAllAsTouched();
            this.formalContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.formalContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            let employeeId = '';
            if (this.formalContractInforForm.getRawValue()?.employee) {
                employeeId = this.formalContractInforForm.getRawValue()?.employee.employeeId;
            }
            this.onApproveContract({
                ...this.formalContractInforForm.getRawValue(),
                contractType: this.selectOption,
                isSendApproval: true,
                status: 'EFFECT',
                note: '',
                employeeCode,
                employeeId
            })
        } else if (this.selectOption == this.probationContractType) {
            this.probationContractInforForm.markAllAsTouched();
            this.probationContractInforForm.markAllAsTouched();
            const invalid = [];
            const controls = this.probationContractInforForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            let employeeId = '';
            if (this.probationContractInforForm.getRawValue()?.employee) {
                employeeId = this.probationContractInforForm.getRawValue()?.employee.employeeId;
            }
            this.onApproveContract({
                ...this.probationContractInforForm.getRawValue(),
                contractType: this.selectOption,
                isSendApproval: true,
                status: 'EFFECT',
                note: '',
                employeeCode,
                employeeId
            });
        }
    }

    onClickReject() {
        this.rejectForm.reset();
        $('#reject_contract_approve_modal').modal('show');
    }

    cancelRejectApprove() {
        $('#reject_contract_approve_modal').modal('hide');
    }

    onClickSubmitReject() {
        this.rejectForm.markAllAsTouched();
        let employeeCode: string = 'AN';
        if (this.data) {
            employeeCode = this.data.employeeProfile.employeeCode;
        } else if (this.employeeCode) {
            employeeCode = this.employeeCode;
        }
        if (this.rejectForm.valid) {
            if (this.selectOption == this.collaboratorsContractType) {
                this.collaboratorsContractInforForm.markAllAsTouched();
                this.collaboratorsContractInforForm.markAllAsTouched();
                const invalid = [];
                const controls = this.collaboratorsContractInforForm.controls;
                for (const name in controls) {
                    if (controls[name].invalid) {
                        invalid.push(name);
                    }
                }
                let employeeId = '';
                if (this.collaboratorsContractInforForm.getRawValue()?.employee) {
                    employeeId = this.collaboratorsContractInforForm.getRawValue()?.employee.employeeId;
                }
                this.onApproveContract({
                    ...this.collaboratorsContractInforForm.getRawValue(),
                    contractType: this.selectOption,
                    isSendApproval: true,
                    status: 'UNAPPROVE',
                    note: this.rejectForm.value.note,
                    employeeCode,
                    employeeId
                });
            } else if (this.selectOption == this.formalContractType) {
                this.formalContractInforForm.markAllAsTouched();
                this.formalContractInforForm.markAllAsTouched();
                const invalid = [];
                const controls = this.formalContractInforForm.controls;
                for (const name in controls) {
                    if (controls[name].invalid) {
                        invalid.push(name);
                    }
                }
                let employeeId = '';
                if (this.formalContractInforForm.getRawValue()?.employee) {
                    employeeId = this.formalContractInforForm.getRawValue()?.employee.employeeId;
                }
                this.onApproveContract({
                    ...this.formalContractInforForm.getRawValue(),
                    contractType: this.selectOption,
                    isSendApproval: true,
                    status: 'UNAPPROVE',
                    note: this.rejectForm.value.note,
                    employeeCode,
                    employeeId
                });
            } else if (this.selectOption == this.probationContractType) {
                this.probationContractInforForm.markAllAsTouched();
                this.probationContractInforForm.markAllAsTouched();
                const invalid = [];
                const controls = this.probationContractInforForm.controls;
                for (const name in controls) {
                    if (controls[name].invalid) {
                        invalid.push(name);
                    }
                }
                let employeeId = '';
                if (this.probationContractInforForm.getRawValue()?.employee) {
                    employeeId = this.probationContractInforForm.getRawValue()?.employee.employeeId;
                }
                this.onApproveContract({
                    ...this.probationContractInforForm.getRawValue(),
                    contractType: this.selectOption,
                    isSendApproval: true,
                    status: 'UNAPPROVE',
                    note: this.rejectForm.value.note,
                    employeeCode,
                    employeeId
                });
            }
            $('#reject_contract_approve_modal').modal('hide');
        }
    }

    onBlur(fieldName: string) {
        if (this.collaboratorsContractInforForm.value && typeof this.collaboratorsContractInforForm.value[fieldName] == 'string') {
            this.collaboratorsContractInforForm.patchValue({
                ...this.collaboratorsContractInforForm.value,
                [fieldName]: this.collaboratorsContractInforForm.value[fieldName].trim()
            });
        }
        if (this.formalContractInforForm.value && typeof this.formalContractInforForm.value[fieldName] == 'string') {
            this.formalContractInforForm.patchValue({
                ...this.formalContractInforForm.value,
                [fieldName]: this.formalContractInforForm.value[fieldName].trim()
            });
        }
        if (this.probationContractInforForm.value && typeof this.probationContractInforForm.value[fieldName] == 'string') {
            this.probationContractInforForm.patchValue({
                ...this.probationContractInforForm.value,
                [fieldName]: this.probationContractInforForm.value[fieldName].trim()
            });
        }
    }

    onBlurRejectApprove() {
        this.rejectForm.setValue({
            note: this.rejectForm.value.note.trim()
        })
    }

    onChangeCvFile(event) {
    }

    getFileName(value) {
        let result = '';
        if (value) {
            let valueSplit = value.split('/');
            if (valueSplit[valueSplit.length - 1]) {
                return valueSplit[valueSplit.length - 1];
            }
        }
        return result;
    }

    get getEmployeeInfoName() {
        if (this.value) {
            return this.value?.employeeCode + '-' + this.value?.employeeName;
        }
        return ''
    }

    get fileUploadName() {
        if (this.value?.laborContractPath) {
            let splitVal = this.value.laborContractPath.split(';');
            if (splitVal[splitVal.length - 1]) {
                return splitVal[splitVal.length - 1];
            }
        }
        return '';
    }

    get fileUploadAgreementName() {
        if (this.value?.agreementFilePath) {
            let splitVal = this.value.agreementFilePath.split(';');
            if (splitVal[splitVal.length - 1]) {
                return splitVal[splitVal.length - 1];
            }
        }
        return '';
    }

    get fileUploadDecisionName() {
        if (this.value?.decisionFilePath) {
            let splitVal = this.value.decisionFilePath.split(';');
            if (splitVal[splitVal.length - 1]) {
                return splitVal[splitVal.length - 1];
            }
        }
        return '';
    }

    get fileUploadPath() {
        if (this.value?.laborContractPath) {
            let splitVal = this.value.laborContractPath.split(';');
            if (splitVal[0]) {
                return splitVal[0];
            }
        }
        return '';
    }

    get fileUploadAgreementPath() {
        if (this.value?.agreementFilePath) {
            let splitVal = this.value.agreementFilePath.split(';');
            if (splitVal[0]) {
                return splitVal[0];
            }
        }
        return '';
    }

    get fileUploadDecisionPath() {
        if (this.value?.decisionFilePath) {
            let splitVal = this.value.decisionFilePath.split(';');
            if (splitVal[0]) {
                return splitVal[0];
            }
        }
        return '';
    }

    getDisabledFile(form: FormGroup) {
        return form.get('laborContractPath') ? form.get('laborContractPath').disabled : false;
    }

    get isShowTerminateDate() {
        return this.value?.laborContractStatus == 'EFFECT' || this.value?.laborContractStatus == 'EXPIRED';
    }


    canEditContractInfo() {
        return this.canEdit
    }

    onDownloadFile(fileName, filePath) {
        this.fileService.getFileByPath(filePath).subscribe(data => {
            const blob = this.fileService.convertBase64ToBlob(data.data, MIME_TYPE.PDF);
            this.modalRef = this.modalService.show(ContractViewComponent, {
                initialState: {
                    fileName: fileName,
                    blob: blob
                },
                class: 'modal-left modal-dialog-centered w-70 max-width-modal expand',
                ignoreBackdropClick: true
            });
        }, error => {
            if (error.error.status) {
                this.toastrMessage.showMessageError(error.error.status.code,
                    error.error.status.message);
            }
        });
    }

    canSendApprovalContract() {
        return this.canSendApprove
    }

    canApprovalContract() {
        return this.canApprove
    }

    canCancelApprovalContract() {
        return this.canApprove
    }

    onlyView() {
        if (!this.canEdit && !this.canApprove && !this.canSendApprove) {
            return true;
        }

        return this.value?.laborContractStatus && this.value?.laborContractStatus !== 'PENDING' && this.value?.laborContractStatus !== 'UNAPPROVE' && this.value?.laborContractStatus !== 'EFFECT';
    }

    changeContractPath() {
        if (!this.value) return;
        this.value.laborContractPath = '';
    }

    closeModal() {
        this.modalRef.hide();
    }

    changeContractTerm(form: FormGroup, event) {
        form.get('contractTerm').setValue(event.target.value);
    }

    submit(data) {
        if(data.contractTerminationDate){
            data.contractTerminationDate = this.datePipe.transform(data.contractTerminationDate, 'dd/MM/yyyy');
        }
        if(data.agreementSigningDate){
            data.agreementSigningDate = this.datePipe.transform(data.agreementSigningDate, 'dd/MM/yyyy');
        }
        if(data.decisionSigningDate){
            data.decisionSigningDate = this.datePipe.transform(data.decisionSigningDate, 'dd/MM/yyyy');
        }
        if(data.startDate){
            data.startDate = this.datePipe.transform(data.startDate, 'dd/MM/yyyy');
        }
        if(data.endDate){
            data.endDate = this.datePipe.transform(data.endDate, 'dd/MM/yyyy');
        }
        const formData = new FormData();
        if(data.laborContractPath){
            formData.append("contractFile", data.laborContractPath);
        }
        if(data.agreementFilePath){
            formData.append("agreementFile", data.agreementFilePath);
        }
        if(data.decisionFilePath){
            formData.append("decisionFile", data.decisionFilePath);
        }
        for(let key in data){
            if(!data[key]){
                delete data[key];
            }
        }
        if(data['agreementFilePath']){
            delete data['agreementFilePath'];
        }
        if(data['decisionFilePath']){
            delete data['decisionFilePath'];
        }
        if(data['laborContractPath']){
            delete data['laborContractPath'];
        }
        if(data.id){
            formData.append("request", new Blob([JSON.stringify(data)], {
                type: 'application/json'
            }));
            this.contractService.update(formData, data.id).subscribe((result) => {
                this.toastr.success("Cập nhật dữ liệu thành công");
                this.onSubmit.emit(true);
            }, (error) => {
                this.toastr.error(error.error.message);
            })
        }else{

            formData.append("createLaborContractReq", new Blob([JSON.stringify(data)], {
                type: 'application/json'
            }));
            this.contractService.create(formData).subscribe((result: any) => {
                if (result.success) {
                    this.toastr.success("Thêm mới hợp đồng thành công");
                    this.onSubmit.emit(true);
                } else {
                    this.toastr.error(result.message);
                }
            }, (error) => {
                this.toastr.error(error.error.message);
            })
        }
    }

    onApproveContract(data: any = null) {
        if(data.contractTerminationDate){
            data.contractTerminationDate = this.datePipe.transform(data.contractTerminationDate, 'dd/MM/yyyy');
        }
        if(data.startDate){
            data.startDate = this.datePipe.transform(data.startDate, 'dd/MM/yyyy');
        }
        if(data.endDate){
            data.endDate = this.datePipe.transform(data.endDate, 'dd/MM/yyyy');
        }
        const body = {
            status: data.status,
            note: data.note,
            laborContractDTO: data
        };
        this.contractService.updateStatus(body, data.id).subscribe((result : any) => {
            this.toastr.success("Cập nhật dữ liệu thành công", "Thông báo");
            this.onApprove.emit(true);
        }, (error) => {
            this.toastr.error(error.error.message);
        })
    }
}
